import moment from "moment";
import formatDateTime, { combineDateTimeToISO } from "./formatDateTime";

const formatValidityPeriod = (validity, format = "DD MMM YYYY, h:mma") => {
  if (!validity || !validity?.fromDate || !validity?.toDate) return null;

  const fromDate = validity.startTime
    ? formatDateTime(
        combineDateTimeToISO(validity.fromDate, validity.startTime),
        "DD MMM YYYY HH:mm"
      )
    : formatDateTime(validity.fromDate, "DD MMM YYYY HH:mm");
  const toDate = validity.endTime
    ? formatDateTime(combineDateTimeToISO(validity.toDate, validity.endTime), "DD MMM YYYY HH:mm")
    : formatDateTime(validity.toDate, "DD MMM YYYY HH:mm");

  return [
    moment(fromDate).format(validity.startTime ? format : "DD MMM YYYY"),
    moment(toDate).format(validity.endTime ? format : "DD MMM YYYY"),
  ].join(" - ");
};

export default formatValidityPeriod;
